import { RArray } from "../../collections";
import { Tristate, } from "../../core";
import { makeImmutable } from "../../core/makeImmutable";
export class Schedule {
    constructor(params) {
        this.id = params.id;
        this.schedule = params.schedule;
        makeImmutable(this);
    }
    includes(date) {
        return this.schedule.includes(date);
    }
    get associationKey() {
        return this.id.associationKey;
    }
    state({ times, now }) {
        // Available no matter what fulfillment time we choose -> yes
        if (times.every((t) => this.includes(t))) {
            return { available: Tristate.True, hours: RArray.empty() };
        }
        // Available or not, depending on what fulfillment time we choose -> maybe
        if (times.some((t) => this.includes(t))) {
            return {
                available: Tristate.Maybe,
                hours: this.schedule.rangesAround(now),
            };
        }
        // Not available, no matter what fulfillment time we choose -> no
        return {
            available: Tristate.False,
            hours: this.schedule.rangesAround(now),
        };
    }
}
